export default __webpack_public_path__ + "static/media/6 Core Stability Workouts.0be41ee0.webp";